// FETCH ALL PROCESS_SUPPLIER
export const FETCH_PROCESS_SUPPLIER_REQUEST = 'FETCH_PROCESS_SUPPLIER_REQUEST';
export const FETCH_PROCESS_SUPPLIER_SUCCESS = 'FETCH_PROCESS_SUPPLIER_SUCCESS';
export const FETCH_PROCESS_SUPPLIER_FAILURE = 'FETCH_PROCESS_SUPPLIER_FAILURE';
// FETCH ALL PROCESS_SUPPLIER
export const FETCH_PROCESS_SUPPLIER_DROPDOWN_REQUEST = 'FETCH_PROCESS_SUPPLIER_DROPDOWN_REQUEST';
export const FETCH_PROCESS_SUPPLIER_DROPDOWN_SUCCESS = 'FETCH_PROCESS_SUPPLIER_DROPDOWN_SUCCESS';
export const FETCH_PROCESS_SUPPLIER_DROPDOWN_FAILURE = 'FETCH_PROCESS_SUPPLIER_DROPDOWN_FAILURE';

// CREATE PROCESS_SUPPLIER
export const CREATE_PROCESS_SUPPLIER_REQUEST = 'CREATE_PROCESS_SUPPLIER_REQUEST';
export const CREATE_PROCESS_SUPPLIER_SUCCESS = 'CREATE_PROCESS_SUPPLIER_SUCCESS';
export const CREATE_PROCESS_SUPPLIER_FAILURE = 'CREATE_PROCESS_SUPPLIER_FAILURE';

// UPDATE PROCESS_SUPPLIER
export const UPDATE_PROCESS_SUPPLIER_REQUEST = 'UPDATE_PROCESS_SUPPLIER_REQUEST';
export const UPDATE_PROCESS_SUPPLIER_SUCCESS = 'UPDATE_PROCESS_SUPPLIER_SUCCESS';
export const UPDATE_PROCESS_SUPPLIER_FAILURE = 'UPDATE_PROCESS_SUPPLIER_FAILURE';

// FETCH SINGLE STATE OF PROCESS_SUPPLIER
export const FETCH_SINGLE_PROCESS_SUPPLIER_REQUEST = 'FETCH_SINGLE_PROCESS_SUPPLIER_REQUEST';
export const FETCH_SINGLE_PROCESS_SUPPLIER_SUCCESS = 'FETCH_SINGLE_PROCESS_SUPPLIER_SUCCESS';
export const FETCH_SINGLE_PROCESS_SUPPLIER_FAILURE = 'FETCH_SINGLE_PROCESS_SUPPLIER_FAILURE';

// DELETE PROCESS_SUPPLIER
export const DELETE_PROCESS_SUPPLIER_REQUEST = 'DELETE_PROCESS_SUPPLIER_REQUEST';
export const DELETE_PROCESS_SUPPLIER_SUCCESS = 'DELETE_PROCESS_SUPPLIER_SUCCESS';
export const DELETE_PROCESS_SUPPLIER_FAILURE = 'DELETE_PROCESS_SUPPLIER_FAILURE';

export const RESET_PROCESS_SUPPLIER_INFO = 'RESET_PROCESS_SUPPLIER_INFO';

export const CREATE_PROCESS_SUPPLIER_FORM = 'CREATE_PROCESS_SUPPLIER_FORM';

export const UPDATE_PROCESS_SUPPLIER_FORM = 'UPDATE_PROCESS_SUPPLIER_FORM';
